import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';

// render pages
const CalendarList = Loadable(lazy(() => import('pages/calendar/List')));
const CalendarCreate = Loadable(lazy(() => import('pages/calendar/Create')));
const CalendarEdit = Loadable(lazy(() => import('pages/calendar/Edit')));

// ==============================|| PARTNER SUB ROUTING ||============================== //
const CalendarRoutes: RouteObject = {
    path: 'calendar',
    children: [
        {
            path: 'entries',
            element: <CalendarList />,
        },
        {
            path: 'entries/new',
            element: <CalendarCreate />,
        },
        {
            path: 'entries/:id',
            element: <CalendarEdit />,
        },
    ],
};
export default CalendarRoutes;
